
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/EditProjectAttribute/EditProjectAttribute.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./EditProjectAttribute.html');
        
        var script = require('./EditProjectAttribute.ts').default;
        module.exports = require('./EditProjectAttribute.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    